"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  clientSuccessfullyCreated: {
    "id": "clients.clientSuccessfullyCreated",
    "defaultMessage": "Client was successfully created."
  },
  clientSuccessfullyUpdated: {
    "id": "clients.clientSuccessfullyUpdated",
    "defaultMessage": "Client was successfully updated."
  },
  clientSuccessfullyDeleted: {
    "id": "clients.clientSuccessfullyDeleted",
    "defaultMessage": "Client was successfully deleted."
  },
  errorDuringClientCreation: {
    "id": "clients.errorDuringClientCreation",
    "defaultMessage": "An error occurred while creating a new client."
  },
  errorDuringClientUpdate: {
    "id": "clients.errorDuringClientUpdate",
    "defaultMessage": "An error occurred while updating a client."
  },
  errorDuringClientDeletion: {
    "id": "clients.errorDuringClientDeletion",
    "defaultMessage": "An error occurred while deleting a client."
  },
  errorDuringClientsFetch: {
    "id": "clients.errorDuringClientsFetch",
    "defaultMessage": "An error occurred while fetching the clients."
  },
  clientAlreadyExists: {
    "id": "clients.clientAlreadyExists",
    "defaultMessage": "Client with this ID already exists."
  },
  clientName: {
    "id": "clients.clientName",
    "defaultMessage": "Name"
  },
  redirectUris: {
    "id": "clients.redirectUris",
    "defaultMessage": "Redirect URIs"
  },
  redirectUrisPlaceholder: {
    "id": "clients.redirectUrisPlaceholder",
    "defaultMessage": "Enter URIs to redirect"
  },
  postLogoutRedirectUris: {
    "id": "clients.postLogoutRedirectUris",
    "defaultMessage": "Post Logout Redirect URIs"
  },
  postLogoutRedirectUrisPlaceholder: {
    "id": "clients.postLogoutRedirectUrisPlaceholder",
    "defaultMessage": "Enter URIs to redirect post logout"
  },
  allowedCors: {
    "id": "clients.allowedCors",
    "defaultMessage": "Allowed CORS"
  },
  allowedCorsPlaceholder: {
    "id": "clients.allowedCorsPlaceholder",
    "defaultMessage": "Enter allowed CORS"
  },
  allowedGrantTypes: {
    "id": "clients.allowedGrantTypes",
    "defaultMessage": "Allowed Grant Types"
  },
  requireConsent: {
    "id": "clients.requireConsent",
    "defaultMessage": "Require Consent"
  },
  clientNamePlaceholder: {
    "id": "clients.clientNamePlaceholder",
    "defaultMessage": "Choose a name"
  },
  clientIdPlaceholder: {
    "id": "clients.clientIdPlaceholder",
    "defaultMessage": "Enter the unique ID"
  },
  accessTokenLifetimeSeconds: {
    "id": "clients.accessTokenLifetimeSeconds",
    "defaultMessage": "Access Token Lifetime"
  },
  accessTokenLifetimeSecondsPlaceholder: {
    "id": "clients.accessTokenLifetimeSecondsPlaceholder",
    "defaultMessage": "Enter token lifetime"
  },
  allowOfflineAccess: {
    "id": "clients.allowOfflineAccess",
    "defaultMessage": "Allow offline access"
  },
  addNewClient: {
    "id": "clients.addNewClient",
    "defaultMessage": "Add new client"
  },
  updateClient: {
    "id": "clients.updateClient",
    "defaultMessage": "Update client"
  },
  scopes: {
    "id": "clients.scopes",
    "defaultMessage": "Scopes"
  },
  roles: {
    "id": "clients.roles",
    "defaultMessage": "Roles"
  },
  selectRoles: {
    "id": "clients.selectRoles",
    "defaultMessage": "Select roles"
  },
  accessTokenType: {
    "id": "clients.accessTokenType",
    "defaultMessage": "Access Token Type"
  },
  clientSecret: {
    "id": "clients.clientSecret",
    "defaultMessage": "Client secret"
  },
  createClientSecret: {
    "id": "clients.createClientSecret",
    "defaultMessage": "Create a client secret"
  },
  mustBeAnInteger: {
    "id": "clients.mustBeAnInteger",
    "defaultMessage": "{param} must be an integer."
  },
  deleteClient: {
    "id": "clients.deleteClient",
    "defaultMessage": "Delete client"
  },
  deleteDesc: {
    "id": "clients.deleteDesc",
    "defaultMessage": "Are you sure you want to delete this client?"
  },
  deleteDesc2: {
    "id": "clients.deleteDesc2",
    "defaultMessage": "This action cannot be undone."
  },
  selectAClientToUpdateIt: {
    "id": "clients.selectAClientToUpdateIt",
    "defaultMessage": "Select a client to see or edit its details."
  },
  seconds: {
    "id": "clients.seconds",
    "defaultMessage": "seconds"
  },
  atLeastOneGrantTypeIsRequired: {
    "id": "clients.atLeastOneGrantTypeIsRequired",
    "defaultMessage": "At least one Allowed Grant Type has to be assigned to a User."
  },
  tenant: {
    "id": "clients.tenant",
    "defaultMessage": "Tenant"
  },
  tenantClient: {
    "id": "clients.tenantClient",
    "defaultMessage": "Tenant Client"
  },
  selectATenant: {
    "id": "clients.selectATenant",
    "defaultMessage": "Select a tenant"
  },
  systemClient: {
    "id": "clients.systemClient",
    "defaultMessage": "System Client"
  },
  tenantHint: {
    "id": "clients.tenantHint",
    "defaultMessage": "A tenant of the current user will be set automatically, if it is not selected from the list."
  }
});
exports.messages = messages;
//# sourceMappingURL=clients-i18n.js.map